/* eslint-disable */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { X, Send, Loader2, Mail } from "lucide-react";

export default function SendDocEmailModal({ doc, onClose, onSent }) {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState(doc?.last_sent_to || "");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async () => {
    if (!/^\S+@\S+\.\S+$/.test(email)) return toast.error(t("docs.invalidEmail"));
    setBusy(true);
    try {
      await api.post(`/documents/${doc.id}/send-email`, { to_email: email, message: message || null, lang: i18n.language });
      toast.success(t("docs.sentTo", { email }));
      onSent && onSent(email);
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || t("docs.sendError"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/60 flex items-end sm:items-center justify-center sm:p-4" onClick={() => !busy && onClose()} data-testid="send-email-modal">
      <div onClick={(e) => e.stopPropagation()} className="bg-[#0B111D] border border-[#1E293B] w-full max-w-md rounded-t-2xl sm:rounded-2xl overflow-hidden">
        <div className="flex items-center justify-between p-4 border-b border-[#1E293B]">
          <div className="font-display font-bold text-lg flex items-center gap-2"><Mail size={18} className="text-[#00BFFF]" /> {t("docs.sendEmailTitle")}</div>
          <button onClick={onClose} disabled={busy} className="text-[#94A3B8] hover:text-[#E2E8F0] disabled:opacity-40"><X size={18} /></button>
        </div>
        <div className="p-5 space-y-4">
          <div className="text-xs text-[#94A3B8] truncate">{t("docs.document")}: <span className="text-[#E2E8F0] font-semibold">{doc?.title}</span></div>
          <div>
            <label className="overline block mb-2">{t("docs.beneficiaryEmail")}</label>
            <input className="input-flat" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("docs.emailPh")} data-testid="send-email-input" autoFocus />
          </div>
          <div>
            <label className="overline block mb-2">{t("docs.messageOptional")}</label>
            <textarea rows={3} className="input-flat" value={message} onChange={(e) => setMessage(e.target.value)} placeholder={t("docs.messagePh")} data-testid="send-email-message" />
          </div>
          <div className="text-xs text-[#5B6B82]">{t("docs.pdfAttached")}</div>
        </div>
        <div className="flex justify-end gap-2 p-4 border-t border-[#1E293B] safe-pb">
          <button onClick={onClose} disabled={busy} className="btn-outline">{t("docs.cancel")}</button>
          <button onClick={send} disabled={busy} className="btn-primary flex items-center gap-2 disabled:opacity-50" data-testid="send-email-confirm">
            {busy ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />} {t("docs.send")}
          </button>
        </div>
      </div>
    </div>
  );
}
